import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { getSlotStyle, getStateName } from '../../utils/helpers';

const Marketplace = ({ slots, currentSlot, submitAotBid, submitJitBid, playerStats, isMobile }) => {
    const { theme } = useTheme();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? '24px' : '34px' }}>
            <div style={{
                backgroundColor: theme.panelBg,
                borderRadius: '10px',
                boxShadow: '0 4px 7px rgba(40, 40, 40, 1)',
                animation: 'bubbleAppear 0.5s ease-in-out'
            }}>
                <div style={{
                    padding: isMobile ? '17px' : '26px',
                    borderBottom: `3px solid ${theme.accent}`,
                    textAlign: 'center'
                }}>
                    <h3 style={{
                        color: theme.gold,
                        fontWeight: 'bolder',
                        textTransform: 'uppercase',
                        margin: '0',
                        fontSize: isMobile ? '28px' : '39px'
                    }}>
                        Slot Marketplace
                    </h3>
                </div>
                <div style={{ padding: isMobile ? '17px' : '26px' }}>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: isMobile ? 'repeat(5, 1fr)' : 'repeat(10, 1fr)',
                        gap: isMobile ? '6px' : '8px',
                        marginBottom: isMobile ? '17px' : '26px'
                    }}>
                        {slots.map(slot => (
                            <div
                                key={slot.slot_number}
                                style={{
                                    ...getSlotStyle(slot.state, theme),
                                    padding: isMobile ? '8px' : '12px',
                                    borderRadius: '5px',
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    transition: 'transform 0.3s ease',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    fontSize: isMobile ? '10px' : '12px',
                                    boxShadow: '0 2px 4px rgba(40, 40, 40, 0.7)'
                                }}
                                onClick={() => {
                                    if ((slot.slot_number >= currentSlot + 1 && slot.state === 'Available') || (typeof slot.state === 'object' && slot.state.AotAuction)) {
                                        submitAotBid(slot.slot_number);
                                    }
                                }}
                                onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                            >
                                <div style={{ fontWeight: 'bolder', marginBottom: '2px' }}>{slot.slot_number}</div>
                                <div style={{ fontSize: isMobile ? '8px' : '10px' }}>{getStateName(slot.state)}</div>
                            </div>
                        ))}
                    </div>

                    <div style={{
                        display: 'flex',
                        gap: isMobile ? '12px' : '17px',
                        flexDirection: isMobile ? 'column' : 'row',
                        alignItems: isMobile ? 'stretch' : 'flex-start'
                    }}>
                        <button
                            onClick={submitJitBid}
                            style={{
                                backgroundColor: '#16a085',
                                color: 'white',
                                padding: isMobile ? '17px' : '20px 34px',
                                border: 'none',
                                borderRadius: '5px',
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                cursor: 'pointer',
                                fontFamily: 'monospace',
                                boxShadow: '0 4px 7px rgba(40, 40, 40, 1)',
                                transition: 'transform 0.3s ease',
                                fontSize: isMobile ? '18px' : '20px',
                                minHeight: '44px'
                            }}
                            onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                            onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                        >
                            Submit JIT Bid (Next Slot)
                        </button>

                        <div style={{
                            backgroundColor: theme.cardBg,
                            padding: isMobile ? '17px' : '20px',
                            borderRadius: '5px',
                            boxShadow: '0 4px 7px rgba(40, 40, 40, 1)',
                            flex: '1'
                        }}>
                            <h4 style={{
                                color: theme.text,
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                margin: '0 0 12px 0',
                                fontSize: isMobile ? '16px' : '18px'
                            }}>
                                Legend
                            </h4>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(3, 1fr)',
                                gap: isMobile ? '8px' : '12px',
                                fontSize: isMobile ? '14px' : '16px'
                            }}>
                                {[
                                    { color: '#16a085', label: 'Available' },
                                    { color: '#297cb3', label: 'JIT Auction' },
                                    { color: theme.accent, label: 'AOT Auction' },
                                    { color: theme.gold, label: 'Reserved' },
                                    { color: '#dc2626', label: 'Filled' },
                                    { color: '#666', label: 'Expired' }
                                ].map(({ color, label }) => (
                                    <div key={label} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <div style={{
                                            width: '16px',
                                            height: '16px',
                                            backgroundColor: color,
                                            borderRadius: '3px',
                                            border: '1px solid rgba(40, 40, 40, 0.3)'
                                        }}></div>
                                        <span style={{
                                            color: theme.text,
                                            fontWeight: 'bold',
                                            textTransform: 'uppercase'
                                        }}>
                                            {label}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Marketplace;
